/** Solid status badges (company active, Auth0 sync, Pro/Pulse, agreement active, SSO configured / error). */
export const ADMIN_BADGE_SOLID_GREEN_CLASS = 'bg-[#3EA943] text-white';
export const ADMIN_BADGE_SOLID_RED_CLASS = 'bg-[#D4173D] text-white';
